export default {
  title: {
    en: 'Main Notes',
  },
}
